import React from "react";
import { Box } from "@mui/material";
import { DotLegalCheckbox, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { isNullOrWhitespace } from "@common/stringOperations.ts";
import { useTranslation } from "@localization/useTranslation.ts";
import { checkboxBelowFieldMargin } from "./IncidentLogFields.styles.ts";

export interface IncidentLogEstimatedNumberFieldProps {
    label: string;
    toolTipText: string;
    value?: number | null;
    isUnknown: boolean;
    onChange: (value: number | null, isUnknown: boolean) => void;
    disabled: boolean;
    errorText?: string;
}

function IncidentLogEstimatedNumberField(props: IncidentLogEstimatedNumberFieldProps) {
    const { translateString } = useTranslation();

    return (
        // The field's own margin would push the checkbox away from it, so the top spacing lives on the wrapper instead.
        <Box sx={{ mt: 2 }}>
            <DotLegalTextField
                label={props.label}
                toolTipText={props.toolTipText}
                noMargin
                value={props.value?.toString() ?? ""}
                onlyNumber="integer"
                debounce
                onChange={(value) => props.onChange(isNullOrWhitespace(value) ? null : Number(value), props.isUnknown)}
                disabled={props.disabled || props.isUnknown}
                errorText={props.errorText}
            />
            <DotLegalCheckbox
                label={translateString("unknown")}
                checked={props.isUnknown}
                onChange={(isUnknown) => props.onChange(isUnknown ? null : (props.value ?? null), isUnknown)}
                disabled={props.disabled}
                margin={checkboxBelowFieldMargin}
            />
        </Box>
    );
}

export default IncidentLogEstimatedNumberField;
